<script setup lang="ts">
defineProps<{
  label?: string;
  error?: boolean;
  disabled?: boolean;
}>();
</script>

<template>
  <div class="ui-schema-host">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.ui-schema-host {
  min-width: 0;
  max-width: 100%;
}
</style>
